<template>
    <div class="container-fluid">
        <v-title :breadcrumb="{label: 'Transactions', route: {name: 'transactions'}, root: true}">
            Transactions
        </v-title>
        <div class="grid flex-flow-column">
            <div class="grid-item">
                <grid
                    :columns="gridColumns"
                    :provider="provider"
                    @completed="stopLoadingPage"
                    :tabs="gridTabs"
                    :filter-set="gridFilterSet"
                >
                    <v-no-content slot="no-content">
                        <span slot="title">It seems that you have no Transactions</span>
                    </v-no-content>
                </grid>
            </div>
        </div>
    </div>
</template>

<script>
    import vTitle from '@/components/v-title';
    import vNoContent from '@/components/v-no-content';
    import Grid from '@/components/grid/grid';
    import LoadStateMixin from '@/mixins/load-state-mixin';
    import TabsConfiguration from '@/components/grid/tabs/tabs-configuration';
    import transactionFilters from '@/common/query/filter/transaction-filters';
    import transactionColumns from './transaction-columns';
    import FilterSet from '@/components/query/filter-set';

    export default {
        name: 'transactions',
        components: {
            vTitle, Grid, vNoContent,
        },
        mixins: [LoadStateMixin],
        data() {
            return {
                gridColumns: transactionColumns,
                gridTabs: new TabsConfiguration({
                    id: 'transactions-list',
                    store: this.$store,
                    systemTabs: [
                        {
                            label: 'All',
                            sortBy: {processedTime: 'desc'},
                        },
                        {
                            label: 'Disputes',
                            sortBy: {processedTime: 'desc'},
                            filter: [['isDisputed', [true]]],
                        },
                        {
                            label: 'Refunds',
                            sortBy: {processedTime: 'desc'},
                            filter: [['type', ['refund']]],
                        },
                        {
                            label: 'DCC',
                            sortBy: {processedTime: 'desc'},
                            filter: [['hasDcc', [true]]],
                        },
                    ],
                    version: 2,
                    filtersVersion: transactionFilters.version,
                }),
                gridFilterSet: new FilterSet({store: this.$store, ...transactionFilters}),
            };
        },
        methods: {
            provider(params) {
                return this.$api(({transactions}) => transactions.getAll(params));
            },
        },
    };
</script>
